import { Wordmark } from "./Logo.tsx";
import { Card, Text, makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  page: { minHeight: "100vh", display: "grid", placeItems: "center", padding: "24px", backgroundColor: tokens.colorNeutralBackground2 },
  card: { width: "min(100%, 440px)", padding: "32px", display: "flex", flexDirection: "column", gap: "16px" },
  brand: { fontSize: tokens.fontSizeHero700, fontWeight: tokens.fontWeightSemibold, color: tokens.colorBrandForeground1 },
});

export function AuthCard({ title, subtitle, children, wide, xwide }: { title: string; subtitle?: string; children: React.ReactNode; wide?: boolean; xwide?: boolean }) {
  const s = useStyles();
  return (
    <div className={s.page}>
      <Card className={s.card} style={xwide ? { width: "min(100%, 1000px)" } : wide ? { width: "min(100%, 620px)" } : undefined}>
        <Wordmark height={48} />
        <div>
          <Text as="h1" size={600} weight="semibold" block>
            {title}
          </Text>
          {subtitle && (
            <Text size={300} block style={{ color: tokens.colorNeutralForeground3 }}>
              {subtitle}
            </Text>
          )}
        </div>
        {children}
      </Card>
    </div>
  );
}
